import { useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { notifySuccess, notifyWarn } from "../services/Toastifyfn";
import { Modal, Button } from "react-bootstrap";

import {
  callLSQLapp,
  encryptBody,
  getLsqLeadBody,
  hashMobileNum
} from "../services/lsq.js";
import { useCookies } from "react-cookie";
import queryString from "query-string";
import {
  submitErrorEvent,
  fieldErrorEvent,
  eventClick,
  formSubmissionFailEvent,
  mainFormStart,
  formIntermediateEventOTP,
  formAbandonEvent,
} from '../services/adobeDataLayer.js';


function Form({ setDataConnect, dataConnect }) {

  let navigate = useNavigate();
  const errorRef = useRef({});

  const [mobile, setmobile] = useState("");
  const [name, setname] = useState("");
  const [checkbox, setcheckbox] = useState("");
  const [otp, setotp] = useState("");
  const [inputs, setInputs] = useState({ "User_Agent": navigator.userAgent });
  const [checked, setChecked] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);

  // otpstatus 0 - blank otp field
  // otptatus 1 - timer enabled on otp field
  // otpstatus 2 - resend button enabled on otp field
  const [otpstatus, setOtpstatus] = useState(0);
  //lsq
  const [otpsent, setOtpsent] = useState(false);
  const [token, setToken] = useState("");
  const [fbp, setFbp] = useState("");
  const [fbc, setFbc] = useState("");
  const [cookies, setCookie] = useCookies();
  const [timer, setTimer] = useState(-1);
  const [ResendBtnText, setRsdBtnText] = useState("Resend");
  const [ResendBTnDisable, setResendBtn] = useState(false)
  const [mobFieldDisable, setMobFieldDisable] = useState(false);
  const [otpFieldDisable, setOtpFieldDisable] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [isDesktop, setIsDesktop] = useState(typeof window !== 'undefined' && window.innerWidth >= 1200);
  const lastAccessedField = useRef("");
  window.adobeDataLayer = window.adobeDataLayer || [];
  //Timer 
  const timeOutCallback = useCallback(
    () => setTimer((currTimer) => currTimer - 1),
    []
  );

  //TnC Modal
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleOpenModal = () => setShowModal(true);

  useEffect(() => {
    if (inputs.mobile?.length === 10 && otpsent) {
      timer > 0 && setTimeout(timeOutCallback, 1000);
    }
  }, [timer, timeOutCallback, inputs.mobile, otpsent]);

  // Track viewport width to position the banner icons (desktop vs mobile/tablet)
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 1200);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Data Layer Log
  // useEffect(() => {
  //   window.adobeDataLayer = window.adobeDataLayer || [];
  //   //console.log(window.adobeDataLayer, "inside form")
  // },[window.adobeDataLayer])

  useEffect(() => {
    if (timer === 0) {
      setOtpstatus(2)
    }
  }, [timer])

  // set Fbp, Fbc, UTM parameters values
  useEffect(() => {
    let fbpVal = cookies["_fbp"] === undefined ? "" : cookies["_fbp"];
    let fbcVal = cookies["_fbc"] === undefined ? "" : cookies["_fbc"];
    setFbp(fbpVal);
    setFbc(fbcVal);
  }, []);

  const mainFormInteraction = useRef(false);

  useEffect(() => {
    // console.log(window.adobeDataLayer.length,"adobe length main form");
    /* check if formstart event is triggered */
    const formStartedFilter = window.adobeDataLayer.filter(eventObj => eventObj.event == "formStarts" && eventObj._icicibank.formInfo.formType == "Lead Generation");
    //console.log(formStartedFilter, "fs fiter");

    /* check if a cta is triggered after formstart */
    if (formStartedFilter.length) {
      //console.log("inside form Start");
      const ctaFilter = window.adobeDataLayer.filter(eventObj => (eventObj.event == "ctaClick" && eventObj._icicibank.ctaInfo.ctaName != "Call Checkbox") || (eventObj.event == "formStarts" && eventObj._icicibank.formInfo.formType == "Calculator") && eventObj._icicibank.dateTime.unixTimestamp > formStartedFilter[0]._icicibank.dateTime.unixTimestamp);
      //console.log(ctaFilter, "ctaFilter")

      if (ctaFilter.length && (!inputs.otp || !inputs.mobile || !inputs.name) && mainFormInteraction.current) {
        formAbandonEvent(lastAccessedField.current, inputs.mobile);
        mainFormInteraction.current = false;
      }
    }

    // setDataConnect(dataConnect+1)
    //console.log("Changed")
    //console.log(window.adobeDataLayer)

  }, [window.adobeDataLayer.length])

  // sendOTPText otp
  const sendOTPText = async (mobileNumber) => {
    // let mobileNumber = e.target.value;
    if (mobileNumber.length === 10 && mobileNumber.match(/^[6-9]\d{9}$/)) {
      let payload = { mobile: mobileNumber, messageType: "otpGeneral" };
      let param = { otp: "send", productType: "GL" };
      const otpResponse = await callLSQLapp(payload, "OTP", param);
      if (otpResponse.data.message.response.sent) {
        formIntermediateEventOTP("receive");
        notifySuccess("OTP has been sent to your mobile number.")
        setOtpstatus(1)
        setTimer(30);
        setOtpsent(true);
        setOtpFieldDisable(false)
      } else if (otpResponse.data.message.response === "MAX OTP Limit reached") {
        window.alert("OTP Limit reached, try again after 5 minutes");
        window.location.reload();
      } else {
        notifyWarn("Please Resend OTP.")
        setRsdBtnText("Resend OTP")
        setOtpstatus(2)
        setOtpFieldDisable(false)
        setTimer(30);
        setOtpsent(false);
      }
    }
  };

  // verifyOTP
  const verifyOTPText = async (mobileNum, otpValue) => {
    let payload = { mobile: mobileNum, otp: otpValue };
    let param = { otp: "verify", productType: "GL" };
    const otpVerifyResponse = await callLSQLapp(payload, "OTP", param);
    if (
      otpVerifyResponse.data.message === "Failure Occured, please check logs"
    ) {
      notifyWarn("Invalid OTP")
      fieldErrorEvent("Invalid OTP", "OTP")
      let myInputs = { ...inputs };
      myInputs.otp = "";
      setInputs(myInputs);
      return;
    }
    const tokenValue =
      otpVerifyResponse.data.message.response.dataSent.UniqueID;
    setToken(tokenValue);
    inputs.otp = otpValue;
    setOtpVerified(true)
    notifySuccess("OTP Verified Successfully.")
    formIntermediateEventOTP("verified");
    setRsdBtnText("Verified")
    setOtpstatus(2)
    setResendBtn(true)
    setMobFieldDisable(true)
    setOtpFieldDisable(true)
  };


  /**
   * this useEffect is being used for sending and verifying otp against the mobile number
   */
  useEffect(() => {
    let mobileVal = inputs["mobile"];
    let OTP = inputs["otp"] ? inputs["otp"] : "";
    if (mobileVal !== undefined) {
      if (mobileVal.length === 10 && otpsent === false) {
        sendOTPText(mobileVal);
      }

      if (mobileVal.length !== 10) {
        setOtpsent(false);
      }
      if (OTP.length === 6 && mobileVal.length === 10 && token === "" && otpVerified === false) {
        verifyOTPText(mobileVal, OTP);
      }
    }
  }, [token, inputs["otp"], inputs["mobile"]]);

  let isValid = 0;
  const handleSubmit = async (event) => {
    event.preventDefault();

    var mobile_reg = /^[6-9]{1}[0-9]{9}$/;

    var name_reg = /^[a-zA-Z ]*$/;

    if (inputs.name === "" || inputs.name === undefined || inputs.name.length <= 2) {
      setname("Please enter your full name");
      // fieldErrorEvent("Blank full name", "Full Name")
      errorRef.current.nameError = "Blank full name"
      isValid++;

    } else {
      if (!inputs.name.match(name_reg)) {
        setname("Please enter valid full name");

        errorRef.current.nameError = "Invalid full name";
        isValid++;
      } else {
        setname("")
        errorRef.current.nameError = "";
      }
    }

    if (!inputs.mobile) {
      setmobile("Please enter your mobile number");
      // fieldErrorEvent("Blank mobile number", "Mobile")
      errorRef.current.mobileError = "Blank mobile number"
      isValid++;

    }
    else {
      if (!inputs.mobile.match(mobile_reg)) {
        setmobile("Please enter valid mobile number");
        errorRef.current.mobileError = "Invalid mobile number"
        isValid++;
      } else {
        setmobile("")
      }
    }

    var otp_reg = /^[0-9]{6}$/;
    if (!inputs.otp) {
      setotp("Blank otp");
      // fieldErrorEvent("Blank otp", "OTP")
      errorRef.current.otpError = "Blank otp"
      isValid++;
    }
    else {
      if (!inputs.otp.match(otp_reg)) {
        errorRef.current.otpError = "Please enter valid otp"
        setotp("Invalid otp number.");
        isValid++;
      } else {
        errorRef.current.otpError = ""
        setotp("")
      }
    }


    if (checked === false) {
      setcheckbox("Please check agree box.")
      // fieldErrorEvent("Unchecked agree box", "Checkbox")
      errorRef.current.checkboxError = "Unchecked agree box";
      isValid++;
    } else {
      setcheckbox("")
      errorRef.current.checkboxError = "Unchecked agree box";
    }


    if (isValid === 0 && otpVerified) {

      setSubmitted(true)
      const utmParamsObj = queryString.parse(window.location.search);
      for (const [key, value] of Object.entries(utmParamsObj)) {
        inputs[key] = value;
      }
      inputs.ApiProductName = "GoldLoan";
      inputs.ModeOfLead = "landing-page";
      inputs.Product = "GoldLoan";
      inputs.Eligible = "Yes";
      inputs.token = token;
      inputs.FBPixelID = fbp;
      inputs.FBClickID = fbc;
      inputs.CompleteUrl = window.location.href;
      inputs.isChecked = checked;
      inputs.CampaignId = "124864";

      if (inputs.mobile) {
        await hashMobileNum(inputs.mobile)
      }

      let lsqInputs = getLsqLeadBody(inputs);
      let payload = {
        mobile: inputs.mobile,
        otp: inputs.otp,
        formdata: lsqInputs,
      };
      console.log("Lead create payload: ", payload);
      let param = { productType: "GL" };
      payload = await encryptBody(payload);
      let createLeadResp = await callLSQLapp(payload, "CREATE", param);
      if (
        createLeadResp.data.message !== "Failure occured , please check logs"
      ) {
        // setApplied(true);
        let leadid = createLeadResp.data.message.Data.LeadApiCalls.Message.Id;
        // window.adobeDataLayer = [];
        navigate(`/thankyou?id=${leadid}`)
      } else {
        //console.log("lead not created.");
        // mainLeadFormSubmit(false);
        formSubmissionFailEvent();
        setSubmitted(false)
        window.alert("Something went Wrong, Please try again later")
      }
    } else {
      //console.log("invalid form")
      const errors = { name: name, otp: otp, mobile: mobile, checkbox: checkbox }
      submitErrorEvent(errorRef.current);
      isValid = 0;
      return false;
    }
  }
  const leadFormStartTrigger = useRef(0);

  const handleChange = (event) => {

    leadFormStartTrigger.current++;
    if (leadFormStartTrigger.current === 1) {
      mainFormStart();
    }
    var name = event.target.name;
    var value = event.target.value;
    if (name == "checkbox" && value == "on") eventClick("Call Checkbox", "Checkbox", "Details Form")
    setInputs(inputs => ({ ...inputs, [name]: value }));
  }
  const handleBlur = (event) => {
    var name = event.target.name;
    lastAccessedField.current = name;
    var mobile_reg = /^[6-9]{1}[0-9]{9}$/;

    var name_reg = /^[a-zA-Z ]*$/;
    if (name === "name") {
      if (inputs.name === "" || inputs.name === undefined || inputs.name.trim().length <= 2) {
        setname("Please enter your full name.");
        fieldErrorEvent("Blank full name", "Full Name")
        isValid++;

      } else {
        if (!inputs.name.match(name_reg)) {
          setname("Please enter valid full name.");
          fieldErrorEvent("Invalid full name.", "Full Name")
          isValid++;
        } else {
          setname("")
          mainFormInteraction.current = true;
        }
      }
    }

    if (name === "mobile") {

      if (!inputs.mobile) {
        setmobile("Please enter your mobile number.");
        fieldErrorEvent("Blank mobile number.", "Mobile")
        isValid++;

      }
      else {
        if (!inputs.mobile.match(mobile_reg)) {
          setmobile("Please enter valid mobile.");
          fieldErrorEvent("Invalid mobile number.", "Mobile Number")
          isValid++;
        } else {
          setmobile("");
          mainFormInteraction.current = true;
        }
      }
    }

    if (name === "otp") {
      var otp_reg = /^[0-9]{6}$/;
      if (!inputs.otp) {
        setotp("Please enter valid otp.");
        fieldErrorEvent("Invalid otp.", "OTP")
        isValid++;
      }
      else {
        if (!inputs.otp.match(otp_reg)) {
          setotp("Please enter valid otp number.");
          fieldErrorEvent("Invalid otp number.", "OTP")
          isValid++;
        } else {
          setotp("");
          mainFormInteraction.current = true;
        }
      }

    }
  }


  return <>

    <article className="banner_section">
      <div className="banner_img" >
        {/* PERF-OPT-2026-08-25: Original LCP picture block retained for rollback.
        <picture>
          <source
            rel="preload"
            media="(max-width:767.5px)"
            srcSet="dist/img/Main-banner-mobile.png"
            alt="ICICI Bank Home Loan Banner"
            width={767}
            height={241}

          />

          <img
            rel="preload"
            src="dist/img/Main-banner-desktop.webp"
            alt="Banner img"
            width={1920}
            height={764}
            className="img-fluid"
          />
        </picture>
        */}
        <picture>
          <source
            media="(max-width:767.5px)"
            srcSet="dist/img/Main-banner-mobile.webp"
            width={375}
            height={281}
            type="image/webp"
          />

          <img
            src="dist/img/Main-banner-desktop.webp"
            alt="ICICI Bank Gold Loan Banner"
            width={1920}
            height={668}
            className="img-fluid"
            fetchPriority="high"
            loading="eager"
            decoding="async"
          />
        </picture>
      </div>
      {/* <div className="container">
        <div className="banner_heading">

          <h1>
            Gold loans at
            <br className="br" /> attractive <br />
            interest rates
          </h1>
        </div>
      </div> */}
      <ul style={{ right: 'auto', left: isDesktop ? '13%' : '3%', top: isDesktop ? '65px' : '70px', gap: '30px' }}>
        <li>
          <div className="banner_content_img" style={{ width: isDesktop ? '100%' : '65%' }}>
            <img
              src="dist/img/interest.svg"
              alt="ICICI Bank"
              className="img-fluid"
            />
          </div>
          <h2>
            Attractive
            <br /> Interest Rate
          </h2>
        </li>
        <li>
          <div className="banner_content_img" style={{ width: isDesktop ? '100%' : '65%' }}>
            <img
              src="dist/img/quick.svg"
              alt="ICICI Bank"
              className="img-fluid"
            />
          </div>
          <h2>
            Quick Loan
            <br /> Disbursement
          </h2>
        </li>
      </ul>
      <div className="container">
        <div className="row">
          <div className="col-lg-7 col-12">
            {/* <ul className="pointers">
              <li>
                <div className="img_wrap ">
                  <img
                    src="dist/img/quick.svg"
                    alt="quick_disbursal"
                    width={94}
                    height={91}
                    color='orange'
                    className="img-fluid CustomCss_quick_disbursal"
                  />
                </div>
                <p className='text-white'>Quick Loan Disbursal</p>
              </li>
              <li>
                <div className="img_wrap ">
                  <img
                    src="dist/img/no_income_icon.webp"
                    alt="quick disbursal"
                    width={94}
                    height={89}
                    className="img-fluid"
                  />
                </div>
                <p>No income proof required</p>
              </li>
              <li className='mt-2'>
                <div className="img_wrap ">
                  <img
                    src="dist/img/no_monthly_emi_icon.webp"
                    alt="quick disbursal"
                    width={86}
                    height={78}
                    className="img-fluid"
                  />
                </div>
                <p>No monthly EMI</p>
              </li>
              <li >
                <div className="img_wrap ">
                  <img
                    src="dist/img/necklace.svg"
                    alt="flexible_repayment"
                    width={66}
                    height={81}
                    className="img-fluid CustomCss_necklace"
                  />
                </div>
                <p className='text-white'>On-spot <br />Valuation</p>
              </li>
            </ul> */}
            <div className="form_wrap" id="apply_gold_loan">
              <div className="form_heading" style={{ textAlign: 'center', background: '#DB620A' }}>
                {/* <h4>Get Gold Loan with minimal documentation</h4> */}
                <h4>Avail Gold Loan at Fixed Interest Rate <br />
                  Fill the form to get an instant callback</h4>

              </div>
              <form name="contactForm" method="post" onSubmit={handleSubmit}>
                <div className='col-12'>
                  <input type="text" name="name" placeholder="Full Name" id="name"
                    value={(inputs.name) ? inputs.name.replace(/[^a-z ]/gi, '') : ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/gi, '')}
                    className={name !== "" ? "errBrdr" : "w-100"}
                  />

                </div>
                {name !== "" ? <span style={{ fontSize: "12px", fontFamily: "sans-serif", fontStretch: "normal", fontStyle: "12px", fontWeight: 400, lineHeight: "normal", letterSpacing: "normal", left: "15px", bottom: 0, color: "red" }}>{name}</span> : null}
                <div>
                  <input type="number" name="mobile" placeholder="Mobile"
                    value={(inputs.mobile > 0) ? inputs.mobile.replace(/^[0-5]+/, '') : ""}
                    pattern="\d{10}"
                    onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    id="mobile_number"
                    disabled={mobFieldDisable}
                    style={{ textAlign: 'left' }}
                    className={mobile !== "" ? "errBrdr" : "w-100"}
                  />
                </div>
                {mobile !== "" ? <span style={{ fontSize: "12px", fontFamily: "sans-serif", fontStretch: "normal", fontStyle: "12px", fontWeight: 400, lineHeight: "normal", letterSpacing: "normal", left: "15px", bottom: 0, color: "red" }}>{mobile}</span> : null}
                <div className={otpstatus === 0 ? 'd-flex align-items-center w-100 mt-1' : 'd-flex align-items-center w-75 mt-1'} >
                  <input className='w-100' type="number" name="otp" placeholder="OTP" id='otp'
                    onInput={(e) => e.target.value = e.target.value.slice(0, 6)}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={otpFieldDisable}
                    value={inputs["otp"] ? inputs["otp"] : ""}
                  />
                  {otpstatus === 2 ?
                    <div className='resend_btn ms-1'>
                      <button
                        onClick={() => sendOTPText(inputs.mobile)}
                        disabled={ResendBTnDisable}
                      >{ResendBtnText}</button>
                    </div> : ""}
                  {otpstatus === 1 ?
                    <div className='timer_wrapper text-center ms-1'>
                      <span id="timer">00:{timer.toString().length < 2 ? timer.toString().padStart(2, '00') : timer}</span>
                    </div> : ""}
                </div>
                {otp !== "" ? <span style={{ fontSize: "12px", fontFamily: "sans-serif", fontStretch: "normal", fontStyle: "12px", fontWeight: 400, lineHeight: "normal", letterSpacing: "normal", left: "15px", bottom: 0, color: "red" }}>{otp}</span> : null}
                <div className="checkbox row">
                  <div className='col-1 check-input p-0'>
                    <input type="checkbox" name="checkbox" id="checkbox"
                      onChange={handleChange}
                      defaultChecked={checked}
                      onClick={() => setChecked(!checked)}
                    />
                  </div>
                  <div className='col-11 p-0 '>
                    <label htmlFor="checkbox">
                      I agree to the{" "}
                      <a
                        href='https://www.icici.bank.in/content/dam/icicibank/india/managed-assets/docs/terms-condition/gold_loan_tnc.pdf?ITM=nli_termsConditions_termsConditions_na_na_55_na_na_NLI'
                        target='_blank'
                        rel='noopener noreferrer'
                        style={{ textDecoration: "none" }}>
                        Terms and Conditions
                      </a>
                      {" "}and{"\u00A0"}
                      <a
                        href='#'
                        onClick={(e) => { e.preventDefault(); handleOpenModal(); }}
                        style={{ textDecoration: "none" }}>
                        Most Important Terms and Conditions
                      </a>
                      {" "}prescribed by ICICI Bank.
                    </label>
                    <Modal show={showModal} onHide={() => { handleCloseModal(); }}>
                      <Modal.Header closeButton onClick={() => { handleCloseModal(); }}>
                        <Modal.Title>TERMS AND CONDITIONS</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <b>DECLARATION</b> <br />
                        I/We hereby confirm my/our interest in availing a Gold Loan facility from ICICI Bank Limited (“ICICI Bank”) and in relation thereto I/we have applied for the loan facility by visiting the [<a href='https://www.icici.bank.in/'>www.icici.bank.in</a>] (“Website”) by submitting my/our application electronically.
                        <br />
                        <br />
                        I/We authorise ICICI Bank and its representatives to contact me by telephone, email, Short Messaging Service (SMS), WhatsApp with respect to products/ facilities hereby applied for.
                        <br />
                        <br />
                        I/We confirm that the information submitted by me/us electronically and the details already available with ICICI Bank (if any) are true, correct, complete and up to date in all respects and that such information can be relied upon by ICICI Bank for the purpose of processing the loan facility.
                        <br />
                        <br />
                        I/We understand that the processing fee is a one-time non-refundable fee collected by ICICI Bank for processing my/our loan request and will not be refunded under any circumstances.
                        <br />
                        <br />
                        I/We understand that the Gold Loan, if sanctioned, shall be subject to ICICI Bank’s internal policies, procedures, and the applicable terms and conditions of the product.
                        <br />
                        <br />
                        I/We hereby authorize ICICI Bank to collect information/personal data from me and other agencies including Unique Identification Authority of India (UIDAI), Credit Information Companies (CICs), and conduct verification/due diligence or make references and enquiries that ICICI Bank may deem fit, for the purpose of the Gold Loan facility.
                        <br />
                        <br />
                        I/We understand that the loan sanction is at the sole discretion of ICICI Bank and ICICI Bank reserves the right to reject the application without assigning any reason. I/We also understand that the loan facility will be disbursed only upon completion of documentation, verification, and other conditions as ICICI Bank may reasonably require.
                        <br />
                        <br />
                        I/We understand that my/our gold articles will be pledged with ICICI Bank as security for the loan and will be released only upon full repayment of the loan and applicable charges.
                        <br />
                        <br />
                        I/We confirm that there are no insolvency proceedings initiated against me/us nor have I/we been adjudicated insolvent/bankrupt in the past.
                        <br />
                        <br />
                        I/We undertake to inform ICICI Bank/its agents of any change in residential address, occupation, or contact details and to provide any further information that ICICI Bank may require.
                        <br />
                        <br />
                        I/We hereby authorize ICICI Bank to exchange, share or part with all information relating to my/our Gold Loan application including credit history and repayment behaviour with credit bureaus, statutory bodies, and such other entities as permitted under law.
                        <br />
                        <br />
                        Except to the extent disclosed to ICICI Bank herein, no Chairman / Managing Director or director or a relative/near relation of a Chairman / Managing Director or director of a banking company (including ICICI Bank and its subsidiaries) or mutual funds/venture capital funds or a relative/near relation of a senior officer of ICICI Bank, as specified by RBI, is: a partner of our concern, trustee, director, employee, guarantor, or holds substantial interest in our concern. Definitions as per RBI Master Circular dated July 1, 2015 shall apply.
                        <br />
                        <br />
                        I/We acknowledge that ICICI Bank reserves the right to retain the documents submitted with this application and shall not be liable to return them.
                        <br />
                        <br />
                        I/We authorize ICICI Bank to store, process, and share all information and data provided herein with its group companies, affiliates, and partners for the purpose of service delivery, marketing, cross-selling, and statutory compliance. I/We shall not hold ICICI Bank liable for such usage or sharing of data.
                        <br />
                        <br />
                        I/We declare that the GSTIN number and billing address provided by me/us is correct, and ICICI Bank is authorized to update the same for charging and reporting purposes under the GST Act.
                        <br />
                        <br />
                        I/We may communicate or submit information/documents electronically to ICICI Bank via email, and I/we understand and accept the risks involved with electronic communication and shall not hold ICICI Bank liable for any issues arising therefrom.
                        <br />
                        <br />
                        I/We consent to receiving information from the Central KYC Registry via SMS/Email on the registered contact details.
                        <br />
                        <br />
                        I/We agree to receive updates, offers, marketing communication, and information about ICICI Bank’s products and services through SMS, Email, Phone Calls, and Social Media.

                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          onClick={() => { handleCloseModal(); }}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                </div>
                {checkbox !== "" ? <span className="agree_span" style={{ fontSize: "12px", fontFamily: "sans-serif", fontStretch: "normal", fontStyle: "12px", fontWeight: 400, lineHeight: "normal", letterSpacing: "normal", position: "relative", bottom: 12, color: "red" }}>{checkbox}</span> : null}

                <div className="applynow">

                  <button disabled={submitted} style={{ background: `${submitted && 'gray'}` }}>{submitted ? "processing" : "Apply Now"}</button>
                </div>
              </form>
              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
    </article >

  </>;
}

export default Form;



// hi this is a text Comment.
